import { WarehouseProductLocationsModule } from '@/shared';

export default WarehouseProductLocationsModule;
